import { useMutation, useQueryClient } from "@tanstack/react-query";
import klydoApiClient from "../../../api/klydo";

// Seal only — no review verdict, no public serving, no creator promotion.
// One-way: nothing un-seals. The refetch picks up the flipped type and the
// promoted asset urls; returning the promise keeps isPending true until the
// modal actually shows the sealed state, so the Seal button cannot flash back
// enabled on a still-Draft cache. The ["klydos"] invalidation moves the row
// out of a DRAFT-filtered Klydos list without a manual refresh — fired but
// not awaited: refetching an active infinite list re-requests every loaded
// page, and only the modal's own klydo refetch needs to gate isPending.
const useSealKlydoMutation = (klydoId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["klydo", klydoId],
    mutationFn: () => klydoApiClient.sealKlydo(klydoId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["klydos"] });
      return queryClient.refetchQueries({ queryKey: ["klydo", klydoId] });
    },
  });
};

export default useSealKlydoMutation;
